import { render } from "./CheckupEntry.vue?vue&type=template&id=f0252f82"
import script from "./CheckupEntry.vue?vue&type=script&lang=js"
export * from "./CheckupEntry.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__